<template>
  <Wrapper
    class="video-navigation-wrapper"
    :styleList="videoWrapperStyle"
    :class="[isMobileEdit && 'mobile-edit-microsite', isMobileView && 'mobile', isPcEdit && 'pc-edit-microsite', isPcView && 'pc']"
    @openEditor="openEditor"
  >
    <VideoNavigation
      v-if="videoNavigationList?.length > 0"
      class="video-navigation"
      :data="videoNavigationList"
      :hiddenVideoInPC="false"
      :isMobile="showMobile"
    ></VideoNavigation>
  </Wrapper>
</template>

<script>
import Wrapper from '../../components/render/wrapper.vue'
import VideoNavigation from '@/components/videoNavigation/videoNavigation.vue'
import RenderMixin from '../renderMixin'
import { MICRO_SITE_DEVICE_TYPE } from '@/constant/common'
import { deviceType } from '@/utils/common'

export default {
  components: {
    Wrapper,
    VideoNavigation
  },
  mixins: [RenderMixin],
  props: {
    rootCompanyId: {
      required: true
    },
    videoNavigationList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      videoWrapperStyle: {}
    }
  },
  computed: {
    siteDeviceType () {
      return this.$route.params.device
    },
    isMobileEdit () {
      return this.siteDeviceType === MICRO_SITE_DEVICE_TYPE.mobile
    },
    isMobileView () {
      if (this.siteDeviceType) {
        return false
      }
      return deviceType.isMobile
    },
    isPcEdit () {
      return this.siteDeviceType === MICRO_SITE_DEVICE_TYPE.pc
    },
    isPcView () {
      if (this.siteDeviceType) {
        return false
      }
      return deviceType.isPc
    },
    showMobile () {
      return this.isMobileEdit || this.isMobileView
    }
  },
  created () {
    this.initPage()
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
    setTimeout(() => {
      this.resizeStyle()
    }, 1500)
  },
  methods: {
    initPage () {
      this.resizeStyle()
    },
    handleWindowResize () {
      this.$nextTick(() => {
        this.resizeStyle()
      })
    },
    resizeStyle () {
      const parentEl = document.querySelector('.microsite-root')
      const marginWidth = (parentEl.clientWidth - 1366) / 2
      const style = {
        position: 'fixed',
        bottom: '110px',
        zIndex: '100',
        margin: `0 ${marginWidth}px`
      }
      if (this.isMobileEdit) {
        style.width = '375px'
        style.margin = '0 auto'
      } else if (this.isMobileView) {
        style.margin = '0 auto'
      } else if (this.isPcEdit) {
        style.minHeight = '150px'
        style.display = 'flex'
        style.justifyContent = 'flex-end'
      } else if (this.isPcView) {
        style.minHeight = '150px'
        style.display = 'flex'
        style.justifyContent = 'flex-end'
      }
      this.videoWrapperStyle = style
    },
    openEditor () {
      this.$emit('openEditor')
    }
  }
}
</script>

<style lang="scss" scoped>
.video-navigation-wrapper {
  min-height: 12vh;
  min-height: 12dvh;
  pointer-events: none;

  ::v-deep {
    .edit-btn-group {
      pointer-events: all;
    }
  }

  .video-navigation {
    position: sticky;
    margin: auto;
    z-index: 10;

    ::v-deep {
      .expend-icon {
        position: absolute;
        top: 25%;
      }
      .video-desc {
        margin-left: 14px;
        .desc {
          pointer-events: all;
        }
        img {
          pointer-events: all;
        }
      }
      .video-swiper {
        z-index: 9999;
        pointer-events: all;
      }
    }
  }
}

.mobile-edit-microsite {
  .video-navigation {
    margin: 50px auto 0 auto;
    ::v-deep {
      .video-desc {
        margin-left: 24px;
        margin-right: 95px;
      }
    }
  }
}

.mobile {
  .video-navigation {
    margin: 50px auto 0 auto;
    ::v-deep {
      .video-desc {
        margin-left: 24px;
        margin-right: 95px;
      }
    }
  }
}

.pc-edit-microsite {
  .video-navigation {
    width: 35%;
    margin: 54px 20px 0 0;
    ::v-deep {
      .collapse-icon {
        width: 22px;
      }
    }
  }
}

.pc {
  .video-navigation {
    width: 35%;
    margin: 54px 20px 0 0;
    ::v-deep {
      .collapse-icon {
        width: 22px;
      }
    }
  }
}
</style>
